import { List, Datagrid, TextField, ImageField } from "react-admin";
import useDataGridStyles from "../components/DataGridStyle";
import { makeStyles } from "@material-ui/core";
import LayoutContainer from "../components/LayoutContainer";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";

const useStyles = makeStyles((theme) => ({
  image: {
    width: 50,
    height: 50,
    objectFit: "cover",
  },
}));

const PaymentChannelList = (props) => {
  const title = "Payment methods";
  const headers = [
    { label: "Name", source: "name" },
    { label: "PrBank name", source: "institute.name" },
    { label: "Method", source: "payment_method.name" },
    { label: "Status", source: "status" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  const imageClasses = useStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Payment methods" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<CustomAction labelCreate="Add Payment" />}
        classes={{ content: classes.content }}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <ImageField
            label="Icon"
            source="image_url"
            classes={{ image: imageClasses.image }}
          ></ImageField>
          <TextField label="Name" source="name" />

          <TextField label="Bank name" source="institute.name" />

          <TextField label="Method" source="payment_method.name" />
          <TextField label="Status" source="status" />
          <CustomDateField label="Created" source="time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Payment_Method" />
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default PaymentChannelList;
